import { apiConfig } from '@constants';

import { isAndroid, isTizen, isVizio, isX1 } from './Platform';

export const getSignupUrl = () => {
  if (isVizio) {
    return apiConfig.VIZIO_SIGN_UP_URL;
  } else if (isX1) {
    return apiConfig.X1_SIGN_UP_URL;
  } else if (isAndroid) {
    return apiConfig.ANDROID_SIGN_UP_URL;
  } else if (isTizen) {
    return apiConfig.SAMSUNG_SIGN_UP_URL;
  } else {
    return apiConfig.WEB_SIGN_UP_URL;
  }
};
